/* eslint-disable prefer-object-spread */

import { getActiveTraceHttpRequestHeaders } from '@atlaskit/react-ufo/experience-trace-id-context';
import { CAPABILITY_HEADER_NAME, ISSUE_VIEW } from '@atlassian/jira-capabilities/src/constants.tsx';
import { getEnhancedCapabilityHeader } from '@atlassian/jira-ufo-capability-header/src/index.tsx';

const defaultOptions = {
	credentials: 'same-origin',
	headers: {
		'Content-Type': 'application/json',
		Accept: ['application/json', 'text/javascript', '*/*'],
	},
} as const;

// @ts-expect-error - TS7006 - Parameter 'options' implicitly has an 'any' type.
const addObservabilityHeaders = (options) =>
	Object.assign({}, options, {
		headers: Object.assign({}, options.headers, {
			[CAPABILITY_HEADER_NAME]: getEnhancedCapabilityHeader(ISSUE_VIEW),
			...getActiveTraceHttpRequestHeaders(),
		}),
	});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (url: string, options: RequestInit = {}) => {
	const mergedOptions = Object.assign({}, defaultOptions, options);
	const requestOptions = addObservabilityHeaders(mergedOptions);

	return fetch(url, requestOptions).then((response) => {
		if (response.ok) {
			return response.json();
		}

		throw new Error(`Fetch call failed with status code: ${response.status}`);
	});
};
